module.exports = __webpack_public_path__ + "static/media/logo_icon.2de2839a.png";